module.exports = __webpack_public_path__ + "5d035eeaa2783d68032069f0e5e31bc3.svg";


//////////////////
// WEBPACK FOOTER
// ./App/assets/camunda/fonts/bpmn.svg
// module id = 305
// module chunks = 0